import React, { Component } from "react";
import axios from "axios";
import Select from "react-select";
import { updateMeasurementType } from "../actions";
import { connect } from "react-redux";

class SelectDataType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: {}
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption });
    if (selectedOption) {
      this.props.onMeasurementUpdate(selectedOption.value);
    } else {
      this.props.onMeasurementUpdate("");
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.previewStatus !== this.props.previewStatus) {
      if (this.props.mType) {
        this.setState({
          selectedOption: {
            value: this.props.mType,
            label: this.props.mType
          }
        });
      }
    }
  }

  componentDidMount() {
    axios
      .get(
        "https://api.ipdata.co/?api-key=616bdd20b2b81d1c6eb609e112f9876f785e0912a5956586af91fe26"
      )
      .then(ipData => {
        let continent = ipData.data.continent_code;
        if (Object.keys(this.state.selectedOption).length == 0) {
          if (continent === "SA" || continent === "NA") {
            this.setState({
              selectedOption: {
                value: "imperial",
                label: "imperial"
              }
            });
            this.props.onMeasurementUpdate("imperial");
          } else {
            this.setState({
              selectedOption: {
                value: "metric",
                label: "metric"
              }
            });
            this.props.onMeasurementUpdate("metric");
          }
        }
      });
  }

  render() {
    return (
      <div>
        <div className="float-right wrapper">
          <label for="measurement_selection">Select measurement type</label>
          <Select
            onChange={this.handleChange}
            placeholder="Select measurement type"
            value={this.state.selectedOption}
            className="measurement_selection"
            options={[
              { value: "imperial", label: "imperial" },
              { value: "metric", label: "metric" }
            ]}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { mType: state.mType, previewStatus: state.previewStatus };
};

const mapActionsToProps = {
  onMeasurementUpdate: updateMeasurementType
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(SelectDataType);



// WEBPACK FOOTER //
// ./src/containers/SelectDataType.js